import React, { useContext } from "react";
import DonorProfile from "../users/DonorProfile";
import RequesterProfile from "../users/RequesterProfile";
import AuthContext from "../../context/AuthContext";

export default function Profile() {
  const { user }: any = useContext(AuthContext);

  return (
    <div>
      {user.userType === "donor" ? (
        <DonorProfile user={user} />
      ) : (
        <RequesterProfile user={user} />
      )}
    </div>
  );
}
